<template>

     <div class="container">

        <div class="handle-box-search">

            <div class="handle-box">

                <el-row class="head-search">

                        <el-col :span="8">
                        <span class="title">司机手机号:</span>
                        <!-- 搜索商家手机号 -->
                        <el-input v-model="search_data.phone" placeholder="请输入司机手机号" class="handle-input mr10"
                              @keyup.enter.native="searchDriverInviteList"></el-input>
                        </el-col>
                        <el-col :span="8">
                        <span class="title">司机邀请码:</span>
                        <!-- 搜索联系人姓名 -->
                        <el-input v-model="search_data.invite_code" placeholder="请输入司机邀请码" class="handle-input mr10"
                              @keyup.enter.native="searchDriverInviteList"></el-input>
                    </el-col>



                </el-row>

            </div>


            <el-button type="primary" icon="el-icon-search" @click="searchDriverInviteList">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button @click="add_isShow = !add_isShow">活动配置</el-button>
        </div>
        <el-table
                :data="tableData"
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"

        >


		    <el-table-column type="index" label="序号">
            </el-table-column>

		    <el-table-column prop="phone" label="司机手机号" min-width="120">
            </el-table-column>

            <el-table-column label="司机姓名" prop="real_name" min-width="130">
            </el-table-column>

            <el-table-column label="司机邀请码" prop="invite_code" min-width="180">
            </el-table-column>

            

            

            

            <el-table-column label="本月邀请用户数" prop="invite_month_num">
            </el-table-column>

            <el-table-column label="累计邀请用户数" prop="invite_total">
            </el-table-column>

            

            

           <el-table-column label="操作" width="180" align="center">
			    <template slot-scope="scope">

                        <!-- 详情按钮 -->
                    <el-button  type="primary"  size="mini" @click="details_isShow = !details_isShow; invite_code = scope.row.invite_code" >查看</el-button>



                </template>
		    </el-table-column>
	    </el-table>

         <!-- 分享配置组件 -->
        <editReward :isShow="add_isShow"></editReward>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 详情组件 -->
        <driverInviteDetails :isShow="details_isShow" :data="invite_code"></driverInviteDetails>



    </div>
</template>

<script>
    var _this;
    import driverInviteDetails from './driverInviteDetails.vue';
    import editReward from './editReward.vue';

    export default {
        components:{
            driverInviteDetails,
            editReward
        },
        data() {
            return {


                details_isShow: false,
                add_isShow: false,

                // 存放表格数据
                tableData: [],

                
                invite_code:'',
            

                //获取用户列表的数据
                search_data: {
                    page: 1,
                    limit: 10,
                    invite_code:'',    
                    phone:''

                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    } ,

                }
            };
        },
        created() {
            _this = this;
            _this.driverInviteList();
        },

        methods: {

            searchDriverInviteList() {
                _this.search_data.page = 1;
                _this.driverInviteList();
            },

            driverInviteList() {
                _this
                    .$post('/Invitecode/getDriverInviteList', _this.search_data, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;


                    })
                    .catch((err) => {});
            },
            //翻页组件的回调
            pages_function(search_data) {
                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.driverInviteList();
            },



            // 刷新按钮
            refresh() {
                this.$router.go(0);
            }



        }

    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        max-width: 150px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-dropdown {
        vertical-align: top;
    }

    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>